import apiData from '../api'
import ImagesDev from '../api/images';
import Link from './Link'
import { Facebook, Twitter, Instagram, Youtube, Mail } from "lucide-react";




function Footer() {
  return (
    <footer className='relative overflow-hidden'>
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-grey-300 via-indigo-800 to-orange-900">
        {/* Animated gradient overlays */}
        <div className="absolute inset-0 opacity-90">
          {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(59,130,246,0.8)_0,rgba(59,130,246,0)_70%)] animate-pulse-slow"></div> */}
          {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(139,92,246,0.8)_0,rgba(139,92,246,0)_70%)] animate-pulse-slow animation-delay-2000"></div> */}
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          {/* <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(236,72,153,0.8)_0,rgba(236,72,153,0)_70%)] animate-pulse-slow animation-delay-400"></div> */}
        </div>

        {/* Animated particle effect */}
        <div className="absolute inset-0 overflow-hidden">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full bg-white opacity-20"
              style={{
                width: `${Math.random() * 6 + 2}px`,
                height: `${Math.random() * 6 + 2}px`,
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animation: `float ${Math.random() * 10 + 10}s linear infinite`,
                animationDelay: `${Math.random() * 10}s`
              }}
            ></div>
          ))}
        </div>
      </div>
      <div className="relative bg-gray-900 text-white py-12 bg-opacity-70">
        <div className="container mx-auto px-6 lg:px-20">
          {/* Footer Top */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <Link to="/" className={`text-1xl flex items-center justify-between`}>
                <img className="w-[12vw] h-[12vw] object-contain" src={ImagesDev.logo} />
              </Link>
            </div>

            {/* About Section */}
            <div>
              <h2 className="text-2xl mb-3 font-phosphate">TSO-MINISTRIES</h2>
              <p className="text-gray-400">
                Spreading the Gospel, transforming lives, and equipping believers
                to walk in the fullness of Christ. Join us in experiencing
                God's power and truth.
              </p>
              <p className="text-[11px] mt-2 text-gray-400">
                TSO Ministries (TitOluwa Olumideko Ministries) — also known as Titoluwa Ministries, TitoTheWriter, and TSO.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h2 className="text-xl font-semibold mb-3">Quick Links</h2>
              <ul className="space-y-2">
                {["Home", "Healing Party", "Bible Study", "Life in the Spirit", "Gallery", "Contact"].map((link, index) => (
                  <li key={index}>
                    <a href={`/${link.toLowerCase().replace(/\s+/g, "-")}`} className="text-gray-400 hover:text-white transition">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact & Socials */}
            <div>
              <h2 className="text-xl font-semibold mb-3">Connect With Us</h2>
              <p className="text-gray-400 mb-3">Have questions or need prayer? Reach out to us.</p>
              <div className="flex space-x-4">
                <a href="mailto:info@tso-ministries.com" className="text-gray-400 hover:text-white transition">
                  <Mail size={24} />
                </a>
                <a href="https://web.facebook.com/profile.php?id=61556604022000" className="text-gray-400 hover:text-white transition">
                  <Facebook size={24} />
                </a>
                <a href="https://x.com/titothewriter?s=21" className="text-gray-400 hover:text-white transition">
                  <Twitter size={24} />
                </a>
                <a href="https://www.instagram.com/titothewriter/" className="text-gray-400 hover:text-white transition">
                  <Instagram size={24} />
                </a>
                <a href="https://www.youtube.com/@titothewriter" className="text-gray-400 hover:text-white transition">
                  <Youtube size={24} />
                </a>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="border-t border-gray-700 mt-8 pt-6 text-center">
            <p className="text-gray-500">&copy; {new Date().getFullYear()} TSO-MINISTRIES. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}



function Footer_() {
  return (
    <footer
      className="bg-tc-blue text-white py-8"
      style={{ background: 'linear-gradient(to left,rgb(43, 9, 54),rgb(116, 22, 144))' }}
    >
      <div className="container mx-auto px-4">
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-8"> */}
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4">
            <img src={`${apiData.imgUri}sample-bg4.png`} />
          </div>

          <div className='col-span-12 md:col-span-5  text-sm text-left'>
            <h3 className="text-xl font-bold mb-4 mt-6">Contact Us</h3>
            <p>30777 Rancho California Rd #892041</p>
            <p>Temecula, CA 92591</p>
            <p>Email: latangela@thetransformationcollective.org</p>
            <div className='subsection' style={{ marginTop: '5rem' }}>
              <div>
                <h3>Customer Support</h3>
                <p>
                  Have questions or need assistance? Our dedicated
                  team is here to help you resolve any issues
                  or provide guidance. Reach out to us anytime.
                </p>
              </div>

              <div>
                <h3>Feedback and Assistance</h3>
                <p>
                  We value your input! Share your thoughts, suggestions,
                  or inquiries with us. We’re always looking to
                  improve and assist you better.
                </p>
              </div>

              <div>
                <h3>Media Inquiries</h3>
                <p>
                  For press-related questions, interviews, or
                  collaborations, our team is available to connect
                  and provide the necessary information.
                </p>
              </div>
            </div>
          </div>

          <div className='col-span-12 md:col-span-3'>
            <h3 className="text-xl font-bold mb-4 mt-6">Quick Links</h3>
            <ul className="space-y-2  text-sm text-left">
              <li><Link to="/about" className="hover:text-tc-gold">About Us</Link></li>
              <li><Link to="/programs" className="hover:text-tc-gold">Programs</Link></li>
              <li><Link to="/events" className="hover:text-tc-gold">Events</Link></li>
              <li><Link to="/contact" className="hover:text-tc-gold">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} The Transformation Collective. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer